import "@/instrument";
import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerAdminServiceWorker } from "@/utils/registerAdminSW";

const root = ReactDOM.createRoot(document.getElementById("root"), {
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
});
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ resetError }) => (
        <div className="min-h-screen bg-[#060A14] flex items-center justify-center p-6" data-testid="sentry-error-fallback">
          <div className="text-center space-y-4">
            <h1 className="text-white text-xl font-light">Qualcosa è andato storto</h1>
            <p className="text-[#94A3B8] text-sm">L'errore è stato segnalato automaticamente. Riprova.</p>
            <button
              onClick={resetError}
              data-testid="sentry-error-retry-btn"
              className="bg-[#C0C0C0] text-[#060A14] px-5 py-2.5 rounded-sm text-[11px] tracking-[0.28em] uppercase hover:bg-white"
            >
              Riprova
            </button>
          </div>
        </div>
      )}
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);

// PWA: enable the admin service worker only on /admin routes.
if (window.location.pathname.startsWith("/admin")) {
  window.addEventListener("load", registerAdminServiceWorker);
}
